<template>
  <div class="table-wrapper-scroll-y">
    <b-table :items="versions" :fields="fields">
      <template slot="versionDate" slot-scope="{value}">
        <div>{{ value | moment('DD/MM/Y')}}</div>
        <div>{{ value | moment('HH:mm')}}</div>
      </template>
      <template slot="workOrderDate" slot-scope="{value}">
        {{ value | moment('DD/MM/Y')}}
      </template>
    </b-table>
  </div>
</template>

<script>

import { yesOrNo, formatDecimal, translateMealCost } from '@/formatters'

export default {
  name: 'WorkOrderVersionTable',
  props: {
    versions: {type: Array, required: true},
    workOrderType: {type: String, required: false}
  },
  data() {
    return {
      // fields: [
      //   { key: 'versionDate', label: 'Versión', class: 'text-center' },
      //   { key: 'versionUser', label: 'Usuario' },
      //   { key: 'workOrderDate', label: 'Fecha' },
      //   { key: 'preventiveResource', label: 'Recurso', class: 'text-center', formatter: yesOrNo },
      //   { key: 'ordinaryHours', label: 'Horas', class: 'text-center', formatter: formatDecimal },
      //   { key: 'overtimeHours', label: 'Extra', class: 'text-center', formatter: formatDecimal },
      //   { key: 'mealCostType', label: 'Dieta', formatter: translateMealCost },
      //   { key: 'travelKm', label: 'Km', class: 'text-center' },
      //   { key: 'shiftWork', label: 'Turnicidad', class: 'text-center', formatter: yesOrNo },
      //   { key: 'nightShift', label: 'Nocturnidad', class: 'text-center', formatter: yesOrNo },
      //   { key: 'holidayHours', label: 'Festivas', class: 'text-center', formatter: formatDecimal }
      // ]
    }
  },
  computed: {
    fields() {
      // var campos = [
      //   { key: 'versionDate', label: 'Versión', class: 'text-center' },
      //   { key: 'versionUser', label: 'Usuario' },
      //   { key: 'workOrderDate', label: 'Fecha' },
      //   { key: 'preventiveResource', label: 'Recurso', class: 'text-center', formatter: yesOrNo },
      //   { key: 'ordinaryHours', label: 'Horas', class: 'text-center', formatter: formatDecimal },
      //   { key: 'overtimeHours', label: 'Extra', class: 'text-center', formatter: formatDecimal },
      //   { key: 'mealCostType', label: 'Dieta', formatter: translateMealCost },
      //   { key: 'travelKm', label: 'Km', class: 'text-center' },
      //   { key: 'shiftWork', label: 'Turnicidad', class: 'text-center', formatter: yesOrNo },
      //   { key: 'nightShift', label: 'Nocturnidad', class: 'text-center', formatter: yesOrNo }
      // ]
      //
      // var esADM = this.workOrderType != null && this.workOrderType === 'ADM'
      // if (esADM) {
      //   campos.push({ key: 'holidayHours', label: 'Festivas', class: 'text-center', formatter: formatDecimal })
      // } else {
      //   campos.push({ key: 'pauseHours', label: 'Pausa', class: 'text-center', formatter: formatDecimal })
      //   campos.push({ key: 'onCallDuty', label: 'Guardia', class: 'text-center', formatter: yesOrNo })
      //   campos.push({ key: 'saturday', label: 'Sábado', class: 'text-center', formatter: yesOrNo })
      //   campos.push({ key: 'holiday', label: 'Domingo/Festivo', class: 'text-center', formatter: yesOrNo })
      // }
      //
      // return campos

      var campos
      var esADM = this.workOrderType != null && this.workOrderType === 'ADM'
      if (esADM) {
        campos = [
          { key: 'versionDate', label: 'Versión', class: 'text-center' },
          { key: 'versionUser', label: 'Usuario' },
          // {key: 'id', label: 'Parte', thStyle: {width: '75px'}, tdAttr: {width: '75px'}},
          // {
          //   key: 'workOrderType',
          //   label: 'Tipo',
          //   formatter: translateType,
          //   thStyle: {width: '100px'},
          //   tdAttr: {width: '100px'}
          // },
          {key: 'validationStatus', label: 'Estado'},
          {key: 'workOrderDate', label: 'Fecha'},
          // {key: 'employeeName', label: 'Operario'},
          {key: 'projectTitle', label: 'Proyecto', formatter: (v, k, item) => item.projectCodeId + ' - ' + v},
          {key: 'project.client.name', label: 'Cliente', formatter: (v, k, item) => item.clientName},
          {
            key: 'preventiveResource',
            label: 'Recurso',
            class: 'text-center',
            thStyle: {width: '60px'},
            tdAttr: {width: '60px'},
            formatter: yesOrNo
          },
          {key: 'ordinaryHours', label: 'Horas', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
          {key: 'overtimeHours', label: 'Extra', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
          {key: 'holidayHours', label: 'Festivas', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
          {key: 'pauseHours', label: 'Pausa', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
          {
            key: 'mealCostType',
            label: 'Dietas',
            thStyle: {width: '50px'},
            tdAttr: {width: '50px'},
            formatter: v => translateMealCost(v)
          },
          {key: 'travelKm', label: 'Km', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}},
          {
            key: 'shiftWork',
            label: 'Turnicidad',
            class: 'text-center',
            thStyle: {width: '75px'},
            tdAttr: {width: '75px'},
            formatter: yesOrNo
          },
          {
            key: 'nightShift',
            label: 'Nocturnidad',
            class: 'text-center',
            thStyle: {width: '90px'},
            tdAttr: {width: '90px'},
            formatter: yesOrNo
          },
          {
            key: 'onCallDuty',
            label: 'Guardia',
            class: 'text-center',
            thStyle: {width: '60px'},
            tdAttr: {width: '60px'},
            formatter: yesOrNo
          },
          // {
          //   key: 'saturday',
          //   label: 'Sábado',
          //   class: 'text-center',
          //   thStyle: {width: '60px'},
          //   tdAttr: {width: '60px'},
          //   formatter: yesOrNo
          // },
          // {
          //   key: 'holiday',
          //   label: 'Festivo',
          //   class: 'text-center',
          //   thStyle: {width: '60px'},
          //   tdAttr: {width: '60px'},
          //   formatter: yesOrNo
          // },
          {key: 'comments', label: 'Observaciones'}
        ]
      } else {
        campos = [
          { key: 'versionDate', label: 'Versión', class: 'text-center' },
          { key: 'versionUser', label: 'Usuario' },
          // {key: 'id', label: 'Parte', thStyle: {width: '75px'}, tdAttr: {width: '75px'}},
          // {
          //   key: 'workOrderType',
          //   label: 'Tipo',
          //   formatter: translateType,
          //   thStyle: {width: '100px'},
          //   tdAttr: {width: '100px'}
          // },
          {key: 'validationStatus', label: 'Estado'},
          {key: 'workOrderDate', label: 'Fecha'},
          // {key: 'employeeName', label: 'Operario'},
          {key: 'projectTitle', label: 'Proyecto', formatter: (v, k, item) => item.projectCodeId + ' - ' + v},
          {key: 'project.client.name', label: 'Cliente', formatter: (v, k, item) => item.clientName},
          {
            key: 'preventiveResource',
            label: 'Recurso',
            class: 'text-center',
            thStyle: {width: '60px'},
            tdAttr: {width: '60px'},
            formatter: yesOrNo
          },
          {key: 'ordinaryHours', label: 'Horas', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
          {key: 'overtimeHours', label: 'Extra', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
          // {key: 'holidayHours', label: 'Festivas', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
          {key: 'pauseHours', label: 'Pausa', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}, formatter: formatDecimal},
          {
            key: 'mealCostType',
            label: 'Dietas',
            thStyle: {width: '50px'},
            tdAttr: {width: '50px'},
            formatter: v => translateMealCost(v)
          },
          {key: 'travelKm', label: 'Km', class: 'text-center', thStyle: {width: '75px'}, tdAttr: {width: '75px'}},
          {
            key: 'shiftWork',
            label: 'Turnicidad',
            class: 'text-center',
            thStyle: {width: '75px'},
            tdAttr: {width: '75px'},
            formatter: yesOrNo
          },
          {
            key: 'nightShift',
            label: 'Nocturnidad',
            class: 'text-center',
            thStyle: {width: '90px'},
            tdAttr: {width: '90px'},
            formatter: yesOrNo
          },
          {
            key: 'onCallDuty',
            label: 'Guardia',
            class: 'text-center',
            thStyle: {width: '60px'},
            tdAttr: {width: '60px'},
            formatter: yesOrNo
          },
          {
            key: 'saturday',
            label: 'Sábado',
            class: 'text-center',
            thStyle: {width: '60px'},
            tdAttr: {width: '60px'},
            formatter: yesOrNo
          },
          {
            key: 'holiday',
            label: 'Festivo',
            class: 'text-center',
            thStyle: {width: '60px'},
            tdAttr: {width: '60px'},
            formatter: yesOrNo
          },
          {key: 'comments', label: 'Observaciones'}
        ]
      }

      return campos
    }
  }
}

</script>

<style lang="css">

.table-wrapper-scroll-y {
  display: block;
  max-height: 200px;
  overflow-y: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

</style>



// WEBPACK FOOTER //
// src/components/workOrderVersion/WorkOrderVersionTable.vue